export default "__VITE_ASSET__CwMr58qM__"